
import { i18n } from '@/plugins/i18n'

export default function setMeta({ to, next }) {
    // replace half-space

    if(to.meta) {
        if(to.meta.label) {
            document.title = to.meta.label.replace(/‌/g, ' ')
        }else if(to.meta.labelTrans) {
            document.title = i18n.t(to.meta.labelTrans).replace(/‌/g, ' ')
        }else {
            document.title = i18n.t('affili')
        }
    }

    return next()
}